import { takeLatest, all } from 'redux-saga/effects';

import * as nbs from './nbsSaga';

function* actionWatcher() {
  yield takeLatest('NBS_GET_PAGE_DATA', nbs.getNBSPageData);
}

export default function* rootSaga() {
  yield all([actionWatcher()]);
}
